export const ListQueryKey = 'commoditys';
export const DetailQueryKey = 'commodity';

export const Urls = {
  selectUrl: '/commodity/list',
  updateUrl: '/commodity/update',
  deleteUrl: '/commodity/delete',
  createUrl: '/commodity/create',
  detailUrl: '/commodity/detail',
};
